/* Customizer cart preview enhancer
   ================================
   Runs site-wide (loaded from theme.liquid). Wherever a customizer preview URL
   appears as a line-item property value — "Vorschau: https://cdn.shopify.com/.../
   files/preview-<ts>.(jpg|png)" — it replaces the long URL with a thumbnail so the
   customer sees their configured product in the cart (and cart drawer).

   Matching is scoped to our own filename convention (/files/preview-…) to avoid
   touching unrelated links/text. Idempotent + debounced so cart AJAX updates and
   the observer never loop. */
(function () {
  var RX = /https?:\/\/cdn\.shopify\.com\/[^\s"'<>]*\/files\/preview-[^\s"'<>]+\.(?:jpe?g|png)(?:\?[^\s"'<>]*)?/i;

  function styleImg(img) {
    img.alt = 'Vorschau';
    img.loading = 'lazy';
    img.className = 'customizer-cart-preview';
    img.style.cssText =
      'display:block;max-width:120px;width:100%;height:auto;margin-top:6px;' +
      'border:1px solid #ddd;border-radius:6px;';
  }

  // Pin the preview onto a product <img>, and KEEP it pinned: Impact's <line>
  // component re-sets img.src via JS after we run, so a one-shot replace loses.
  // A tiny per-image attribute-observer re-applies whenever src/srcset changes
  // back. Sets BOTH src and srcset so neither wins the original.
  function pinImage(img, url) {
    var pic = img.closest && img.closest('picture');
    if (pic) { var srcs = pic.querySelectorAll('source'); for (var s = 0; s < srcs.length; s++) srcs[s].parentNode.removeChild(srcs[s]); }
    var apply = function () {
      if (img.getAttribute('src') === url && img.getAttribute('srcset') === url) return;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-widths');
      img.removeAttribute('sizes');
      img.setAttribute('srcset', url);
      img.setAttribute('src', url);
      img.setAttribute('style', (img.getAttribute('style') || '') + ';object-fit:contain;background:#fff;');
    };
    apply();
    if (img._czPinned) return;
    img._czPinned = 1;
    try {
      new MutationObserver(apply).observe(img, { attributes: true, attributeFilter: ['src', 'srcset', 'sizes', 'data-src'] });
    } catch (e) { /* attr observer unsupported — one-shot apply above still ran */ }
  }

  // Replace the cart line-item's PRODUCT thumbnail(s) with the customer's preview.
  // NB: don't use closest('[class*="line-item"]') — it matches the INNER
  // line-item__info (which holds the props but no image). Instead walk up to the
  // first ancestor that actually contains a product image = the line row.
  function replaceLineImage(url, fromEl) {
    var node = fromEl, container = null;
    for (var i = 0; i < 12 && node; i++) {
      node = node.parentElement;
      if (node && node.querySelector && node.querySelector('img:not(.customizer-cart-preview)')) { container = node; break; }
    }
    if (!container) return;
    // Impact renders TWO <img class="line-item__media"> per line — pin ALL of them.
    var imgs = container.querySelectorAll('img:not(.customizer-cart-preview)');
    for (var k = 0; k < imgs.length; k++) pinImage(imgs[k], url);
  }

  function enhance() {
    // 1) Anchors whose href is a preview URL → swap the text for the image.
    var anchors = document.querySelectorAll('a[href*="/files/preview-"]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      if (a.getAttribute('data-customizer-img') || !RX.test(a.href)) continue;
      a.setAttribute('data-customizer-img', '1');
      var aImg = document.createElement('img');
      aImg.src = a.href;
      styleImg(aImg);
      a.textContent = '';
      a.appendChild(aImg);
      replaceLineImage(a.href, a);
    }

    // 2) Plain-text occurrences of the URL → replace the URL run with the image.
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var hits = [];
    var n;
    while ((n = walker.nextNode())) {
      var p = n.parentNode;
      if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE' || p.nodeName === 'A') continue;
      if (p.getAttribute && p.getAttribute('data-customizer-img')) continue;
      if (RX.test(n.nodeValue)) hits.push(n);
    }
    for (var j = 0; j < hits.length; j++) {
      var tn = hits[j];
      var m = tn.nodeValue.match(RX);
      if (!m) continue;
      var before = tn.nodeValue.slice(0, m.index);
      var after = tn.nodeValue.slice(m.index + m[0].length);
      var span = document.createElement('span');
      span.setAttribute('data-customizer-img', '1');
      var tImg = document.createElement('img');
      tImg.src = m[0];
      styleImg(tImg);
      span.appendChild(tImg);
      var frag = document.createDocumentFragment();
      if (before) frag.appendChild(document.createTextNode(before));
      frag.appendChild(span);
      if (after) frag.appendChild(document.createTextNode(after));
      tn.parentNode.replaceChild(frag, tn);
      replaceLineImage(m[0], span);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      try { enhance(); } catch (e) { /* never break the page */ }
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Re-run on cart drawer / AJAX cart updates (guarded + debounced → no loop).
  try {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* MutationObserver unavailable — initial pass still ran */ }
})();

/* Customizer bundle cart enforcement
   =================================
   Keeps each personalized "bundle" (the main product line + its surcharge lines,
   sharing a hidden `_cz_bundle` property set by the storefront customizer)
   consistent in the cart — WITHOUT a Cart Transform, which would strip the
   line-item properties (name/font/colour/motif/preview) from the ORDER and break
   production. Purely client-side:
     • surcharge ("fee") lines: quantity locked + "Entfernen" hidden — the customer
       can't delete just the surcharge or change its quantity on its own.
     • the main line quantity stays editable; on every cart change we reconcile
       each fee line's quantity to its main's, and drop orphan fees whose main is
       gone — then refresh so the theme shows the corrected cart.
   Bundle membership + roles are read from /cart.js, which DOES include the
   underscore-prefixed properties even though the theme hides them from display.
   Line rows map 1:1 to cart.js via <line-item data-live-item-key="…">. */
(function () {
  var reconciling = false, cachedCart = null, cachedAt = 0, timer = null;
  function now() { return (window.performance && performance.now) ? performance.now() : +new Date(); }

  function fetchCart() {
    if (cachedCart && (now() - cachedAt) < 800) return Promise.resolve(cachedCart);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cachedCart = c; cachedAt = now(); return c; });
  }

  function changeLine(key, qty) {
    cachedCart = null; // cart is about to change
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  // Roles/bundles per line key + per-bundle main quantity, from /cart.js.
  // Tolerant of both tag spellings: `_cz_bundle`/`_cz_role` (current, hidden) and
  // the brief `cz_bundle`/`cz_role` variant — so lines added by an older cached
  // configurator are still recognized.
  function tag(p, name) { return p['_cz_' + name] || p['cz_' + name]; }
  // A line is a surcharge if it carries the _cz_role=fee tag OR the visible
  // "Aufpreis für" property the configurator always stamps on fee lines — so even a
  // line that lost its bundle tags (e.g. to a cart merge) is still recognised and
  // locked. A normal product never has "Aufpreis für", so no false positives.
  function isFee(p, r) { return r === 'fee' || Object.prototype.hasOwnProperty.call(p, 'Aufpreis für'); }
  function analyze(cart) {
    var role = {}, bundleOf = {}, mainQty = {}, hasMain = {}, mainKey = {}, fees = [];
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      var r = tag(p, 'role');
      // Lock EVERY recognisable surcharge line (even a bundle-less orphan), so the
      // customer can never delete or re-quantify a lone surcharge on its own.
      if (isFee(p, r)) role[it.key] = 'fee';
      var b = tag(p, 'bundle'); if (!b) return;   // no bundle → lock only; can't reconcile
      bundleOf[it.key] = b;
      if (r === 'main') { role[it.key] = 'main'; mainQty[b] = it.quantity; hasMain[b] = true; mainKey[b] = it.key; }
      else if (isFee(p, r)) fees.push(it);
    });
    return { role: role, bundleOf: bundleOf, mainQty: mainQty, hasMain: hasMain,
             mainKey: mainKey, fees: fees };
  }

  // The surcharge line is not a second product — it belongs TO the product above
  // it. Rendered as a full-width row with its own thumbnail it reads like a fee
  // tacked on afterwards, which is what customers complained about. Indent it,
  // mute it, drop its (placeholder) thumbnail and hang a connector off its left
  // edge, so it reads as a sub-line of the product it was configured for.
  //
  // NOT hidden: on Basic the checkout is unstyleable and shows the surcharge line
  // again — hiding it in the cart would make the checkout look like a surprise
  // charge (and PAngV wants the position itemized before the order anyway).
  var STYLE_ID = 'cz-fee-line-style';
  //
  // The connector is a literal "↳", NOT a CSS "\21B3" escape: this CSS lives in a
  // JS string, where a backslash would be eaten as a (bogus) JS escape long before
  // the CSS parser ever sees it.
  var CSS =
    '.cz-fee-row{opacity:.88}' +
    // <tr> on the cart page: padding only applies to the cells, and the row's own
    // top border would draw a divider between product and its surcharge.
    '.cz-fee-row>td{border-top:0!important;padding-top:.25rem;padding-bottom:.25rem}' +
    '.cz-fee-row>td:first-child{padding-left:2.75rem;position:relative}' +
    // <line-item> in the drawer: no table cells, indent the element itself.
    'line-item.cz-fee-row{padding-left:2.75rem;border-top:0!important;position:relative}' +
    // Connector. Anchored to the first CELL on the cart page — generated content on
    // a bare <tr> is not rendered by browsers — and to the element itself in the
    // drawer, which is a normal box.
    '.cz-fee-row>td:first-child::before,line-item.cz-fee-row::before{' +
      'content:"↳";position:absolute;left:1.1rem;top:.35rem;' +
      'font-size:1rem;line-height:1;opacity:.5;pointer-events:none}' +
    // The fee product carries no image → the theme renders a placeholder tile that
    // makes the line look like a separate article. Collapse the media column.
    '.cz-fee-row .line-item__media,.cz-fee-row picture,' +
    '.cz-fee-row img:not(.customizer-cart-preview){display:none!important}' +
    '.cz-fee-row .line-item__title,.cz-fee-row a{font-size:.92em}';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = CSS;
    (document.head || document.documentElement).appendChild(el);
  }

  // Row element for a line key — on the full cart PAGE (Impact main-cart.liquid)
  // the visible quantity input and "Entfernen" link live in a SIBLING <td>,
  // OUTSIDE <line-item>; only the hidden `sm:hidden` mobile copy sits inside it.
  // So scope to the enclosing table row when present; the cart drawer has no <tr>
  // → fall back to the <line-item> element itself.
  function rowFor(el) { return (el.closest && el.closest('tr')) || el; }

  // Lock DOM controls on fee lines and mark them up as sub-lines (idempotent; only
  // touches attributes/styles/order, which our childList observer settles on after
  // one pass → no loop).
  function styleFeeRows(info) {
    ensureStyle();
    var rows = document.querySelectorAll('[data-live-item-key]');
    var byKey = {};
    for (var n = 0; n < rows.length; n++) byKey[rows[n].getAttribute('data-live-item-key')] = rows[n];

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var key = row.getAttribute('data-live-item-key');
      if (info.role[key] !== 'fee') continue;
      var scope = rowFor(row);
      scope.classList.add('cz-fee-row');

      // Keep the surcharge directly beneath its own product. Normally they are
      // already adjacent (added in one /cart/add.js call, and Shopify keeps
      // insertion order), so this is a no-op — it only repairs a cart where the
      // two drifted apart (merged carts, a re-added main line).
      var mainEl = byKey[info.mainKey[info.bundleOf[key]]];
      if (mainEl) {
        var mainRow = rowFor(mainEl);
        if (mainRow.parentNode === scope.parentNode && mainRow.nextElementSibling !== scope) {
          mainRow.parentNode.insertBefore(scope, mainRow.nextSibling);
        }
      }

      var rm = scope.querySelectorAll('a[href*="quantity=0"]');
      for (var j = 0; j < rm.length; j++) rm[j].style.display = 'none';
      var qi = scope.querySelectorAll('input.quantity-input, [is="quantity-input"]');
      for (var k = 0; k < qi.length; k++) {
        qi[k].setAttribute('readonly', 'readonly');
        qi[k].setAttribute('disabled', 'disabled');
        qi[k].style.pointerEvents = 'none';
        qi[k].style.opacity = '0.55';
      }
      var btns = scope.querySelectorAll('line-item-quantity button, quantity-input button');
      for (var s = 0; s < btns.length; s++) btns[s].style.display = 'none';
    }
  }

  function reconcile() {
    if (reconciling) return;
    reconciling = true;
    fetchCart().then(function (cart) {
      var info = analyze(cart);
      styleFeeRows(info);
      var ops = [];
      info.fees.forEach(function (f) {
        var b = info.bundleOf[f.key];
        if (!info.hasMain[b]) { ops.push([f.key, 0]); return; }   // orphan → remove
        if (f.quantity !== info.mainQty[b]) ops.push([f.key, info.mainQty[b]]); // sync qty
      });
      if (!ops.length) { reconciling = false; return; }
      var chain = Promise.resolve();
      ops.forEach(function (op) { chain = chain.then(function () { return changeLine(op[0], op[1]); }); });
      chain.then(function () { window.location.reload(); })
           .catch(function () { reconciling = false; });
    }).catch(function () { reconciling = false; });
  }

  function schedule() {
    if (reconciling || timer) return;
    timer = window.setTimeout(function () { timer = null; try { reconcile(); } catch (e) { reconciling = false; } }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); }
  catch (e) { /* observer unavailable — initial pass still ran */ }
})();
